import { PLANS } from "@utils/pricing";
import { ExpiredPricingPlan } from "../types";

export const currentPlanKey = 'currentPlan';
export const enterpriseBillingPeriodKey = 'enterpriseBillingPeriodKey';
export const paymentPlansKey = 'paymentPlans';
export const paymentMethodsKey = 'paymentMethods';
export const paymentDetails = 'paymentDetails';
export const invoicesKey = 'invoices';
export const totalAggregateKey = 'totalAggregateKey';
export const errorMessage = 'Sorry, something went wrong';
export const expiredPricingPlans: ExpiredPricingPlan[] = [
    {
        title: "Starter Plan",
        price:`$${PLANS.STARTER.ANNUAL_PRICE}`,
        billingCycle: "/ mo billed monthly",
        planType: 'starter',
        features: [
            "One job post",
            "Post jobs to all major job boards",
            "Attract, engage, interview seamlessly",
            "Pre-screening & applicant tagging",
            "Customized, branded careers page",
            "Social & web integration",
            "Unlimited applications & hires"
        ],
        buttonText: "Select Plan"
    },
    {
        title: "Smarter",
        subtitle: "Smarter",
        preTitle: 'Get',
        planType: 'smarter',
        price: `$${PLANS.SMARTER.ANNUAL_PRICE}`,
        disclaimer: "Everything in Starter +",
        billingCycle: "/ mo billed annually",
        features: [
            "Unlimited job posts (go crazy)",
            "Full cycle hiring automation",
            "Hiring analytics",
            "Custom branded QR & hiring graphics",
            "One on one account onboarding",
            "Unlimited support"
        ],
        buttonText: "Select Plan",
        highlighted: true
    },
    {
        title: "Pro",
        subtitle: "Pro",
        planType: 'pro',
        price: `$${PLANS.PRO.ANNUAL_PRICE}`,
        preTitle: 'Go',
        disclaimer: "Everything in Smarter +",
        billingCycle: "/ mo billed annually",
        features: [
            "Digital new hire onboarding",
            "Customized company paperwork",
            "Hiring document storage",
            "Teams management",
            "Multi-user access",
            "Manager permissions & controls"
        ],
        buttonText: "Select Plan"
    }
];